"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { BlockInspectorProps, InspectorProps } from "../../lib/inspector";
import { Quote, type QuoteProps } from "./quote";

export type QuoteInspectorProps = BlockInspectorProps & InspectorProps<"quote">;

export function QuotePreview(props: Readonly<QuoteProps>) {
  const containerInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });

  const quoteInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
    locale: props.sys?.locale,
  });

  return (
    <Quote
      {...props}
      inspectorProps={{
        container: containerInspector({ fieldId: "internalName" }) ?? undefined,
        quote: quoteInspector({ fieldId: "quoteText" }) ?? undefined,
      }}
    />
  );
}
